import React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';

import type { ShippingAddress } from 'types';

import './influencer-shipping-details.scss';

applyTranslations(require('./influencer-shipping-details.i18n.json'));

type Props = {
  values: ShippingAddress,
  centerAligned?: boolean
}

const InfluencerShippingDetails = ({
  values,
  centerAligned
}: Props) => {
  const rowClass = classnames('influencer-shipping-details__row', {
    'influencer-shipping-details__row--center-aligned': centerAligned
  });

  return (
    <div className="influencer-shipping-details">
      <div className={rowClass}>
        <div className="influencer-shipping-details__label">
          {__t('influencer_shipping_details.recipient')}
        </div>
        <div className="influencer-shipping-details__value">
          {values?.recipient}
        </div>
      </div>
      <div className={rowClass}>
        <div className="influencer-shipping-details__label">
          {__t('influencer_shipping_details.address_1')}
        </div>
        <div className="influencer-shipping-details__value">
          {values?.address1}
        </div>
      </div>
      {
        values?.address2 && (
          <div className={rowClass}>
            <div className="influencer-shipping-details__label">
              {__t('influencer_shipping_details.address_2')}
            </div>
            <div className="influencer-shipping-details__value">
              {values?.address2}
            </div>
          </div>
        )
      }
      <div className={rowClass}>
        <div className="influencer-shipping-details__label">
          {__t('influencer_shipping_details.city')}
        </div>
        <div className="influencer-shipping-details__value">
          {values?.city}
        </div>
      </div>
      <div className={rowClass}>
        <div className="influencer-shipping-details__label">
          {__t('influencer_shipping_details.state')}
        </div>
        <div className="influencer-shipping-details__value">
          {values?.stateProvinceRegion || (<span>&mdash;</span>)}
        </div>
      </div>
      <div className={rowClass}>
        <div className="influencer-shipping-details__label">
          {__t('influencer_shipping_details.postal_code')}
        </div>
        <div className="influencer-shipping-details__value">
          {values?.zip}
        </div>
      </div>
      <div className={rowClass}>
        <div className="influencer-shipping-details__label">
          {__t('influencer_shipping_details.country')}
        </div>
        <div className="influencer-shipping-details__value">
          {values?.country}
        </div>
      </div>
    </div>
  );
};

export default InfluencerShippingDetails;
